import { emptyArray } from "constants/defaultValues";

export const getActivityTypes = activityTypes => {
  if (!activityTypes) return emptyArray;

  const result = activityTypes.map(z => {
    return { id: z.id, name: `${z.code} / ${z.name}` };
  });

  return result;
};
